import * as React from 'react';
import styled from 'styled-components';
import { type PaginationProps } from '@mui/material';
import { Pagination } from './Pagination';
import { Select, type SelectOption } from '../Select';

export type AdvancedPaginationProps = PaginationProps & {
  count: number; // the total page number
  page: number; // the current page number
  rowsPerPageOptions?: SelectOption[];
  rowsPerPage?: number;
  recordText?: string;
  onChangeRowsPerPage?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AdvancedPagination: React.FunctionComponent<
  AdvancedPaginationProps
> = (props: AdvancedPaginationProps) => {
  const {
    rowsPerPage,
    rowsPerPageOptions = [],
    recordText = '',
    onChangeRowsPerPage,
    ...rest
  } = props;

  return (
    <PaginationContainer>
      <Pagination {...rest} />
      <Select
        options={rowsPerPageOptions}
        value={rowsPerPage}
        onChange={onChangeRowsPerPage}
      />
      <span style={{ marginLeft: '1rem' }}>{recordText}</span>
    </PaginationContainer>
  );
};

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .MuiFormControl-root {
    margin-left: 1rem;
  }

  .MuiSelect-select {
    padding: 0.4rem;
    width: 5rem;
  }
`;
